module.exports = __webpack_public_path__ + "img/folder.29d77916.svg";